import React from 'react';
import PropTypes from 'prop-types';
import Link from '../../../01_atoms/Link';

const FooterSmallMenu = ({ links = [] }) => {
  return (
    <div className="footer-small-menu">
      <ul>
        {links.map((item) => (
          <li key={item.text}>
            {item.nextLink && (
              <Link {...item.nextLink}>
                <a className="footer-small-menu--link">{item.text}</a>
              </Link>
            )}
          </li>
        ))}
        <li>
          <a
            onClick={(e) => {
              e.preventDefault();
              window.Cookiebot?.renew();
            }}
            href="#"
            className="footer-small-menu--link"
          >
            Manage my cookies
          </a>
        </li>
      </ul>
    </div>
  );
};

FooterSmallMenu.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      nextLink: PropTypes.shape({
        href: PropTypes.string,
        as: PropTypes.string,
      }),
    }),
  ),
};

export default FooterSmallMenu;
